"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Org/SubscriptionsTab/Features/components/PaymentReport.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);







const FeaturePaymentReport = ({
  usageCount,
  title,
  subtitle,
}) => (
  _react2.default.createElement('div', { className: "settings--org-subs--feat--payment-report", __self: this, __source: {fileName: _jsxFileName, lineNumber: 14}}
    , _react2.default.createElement('span', { className: "settings--org-subs--feat--payment-report--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 15}}
      , _react2.default.createElement('span', { className: "settings--org-subs--feat--payment-report--title-count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}
        ,  usageCount 
      )
      ,  title 
    )
    ,  subtitle && false && ( // leave this out for now, so we don't show non-discounted prices to customers with discounts
      _react2.default.createElement('span', { className: "settings--org-subs--feat--payment-report--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}},  subtitle )
    )
  )
)

exports. default = FeaturePaymentReport
